import { FunctionComponent, useEffect, PropsWithChildren } from 'react';
import { Form, useFormikContext } from 'formik';

import { PropsWithClassname } from '@/app/types';

const FormContainer: FunctionComponent<PropsWithChildren<PropsWithClassname>> = (props) => {
  const formikContext = useFormikContext();

  useEffect(() => {
    const firstErrorEl = document.querySelector('.has-error');

    if (formikContext.isSubmitting) {
      firstErrorEl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [formikContext.isSubmitting, formikContext.errors]);

  return <Form className={props.className}>{props.children}</Form>;
};

export default FormContainer;
